import { SystemContext } from '@chakra-ui/react'
import { ChakraThemeKey } from '~/schemas/chakraTheme'
import { aerLingusTheme } from './aerLingus'
import { britishAirwaysTheme } from './britishAirways'
import { aviosTheme } from './avios'

export type ChakraThemeMap = Record<ChakraThemeKey, SystemContext>

export const chakraThemeMap: ChakraThemeMap = {
  aer_lingus: aerLingusTheme,
  british_airways: britishAirwaysTheme,
  avios: aviosTheme,
}
